import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saRrcEstablishmentCellChartConfig } from '../cellChartConfigs';

interface RrcEstablishmentSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const RrcEstablishmentSaCell: React.FC<RrcEstablishmentSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saRrcEstablishmentCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default RrcEstablishmentSaCell;
